import { ApiKeyStatus, Clonable } from '../../..';

export class ApiKey extends Clonable {
  constructor(
    public readonly id: string,
    public readonly teamId: string,
    public readonly hash: string,
    public readonly status: ApiKeyStatus,
    public readonly createdAt: Date,
    public readonly createdBy: string,
    public readonly updatedAt: Date,
    public readonly lastUsedAt?: Date,
  ) {
    super();
  }
}
